<template lang="pug">
    v-autocomplete(dense 
        v-model="dataGroup" 
        :disabled="disabled"
        :readonly="readonly" 
        :label="label" 
        :rules="rules"
        :items="filterGroup" 
        item-text="corporateGroupName" 
        item-value="corporateGroupId" 
        @change="onSelect" 
        :required = "required")
</template>
<script>
export default {
    name: "FSelectGroupCorporate",
    props: [
        "value",
        "disabled",
        "readonly",
        "label",
        "rules",
        "required",
        "corporateId"
    ],
    data() {
        return {
            dataGroup: {},
            listData: []
        }
    },
    computed: {
        filterGroup(){
            return this.listData.filter(f => f.status == 'ACTIVE');
        }
    },
    mounted() {
        this.getGroupByCorporateId();
        this.doInit(this.value);
    },
    watch: {
        value(val){
            this.doInit(val);
        },
        corporateId(val){
            this.getGroupByCorporateId();
        }
    },
    methods: {
        doInit(values){
            this.dataGroup = values ? values : null;
        },
        getGroupByCorporateId(){
            if (this.corporateId) {
                this.$http.get("/api/corporate/group/" + this.corporateId).then(success => {
                    this.listData = success.data;
                });
            }
        },
        getRoleUser(){
            this.$http.get("/api/parameter/user-role").then(success => {
                this.listData = success.data;
                if (this.needVerification) {
                    this.listData = this.listData.filter(f => f.id != 'VRF_USER');
                }
            });
        },
        onSelect() {
            this.$emit("input", this.dataGroup);
            this.$emit("select", this.dataGroup);
            this.$emit("group", this.valueData());
        },
        valueData(){
            let result = null;
            this.listData.map(element => {
                if (this.dataGroup === element.id) {
                    result = element;
                }
            });
            return result;
        },
    },
}
</script>